export default __webpack_public_path__ + "static/media/poisonedblades.95113e15.png";